import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BrowseView, useBrowseViewRef } from '@pro4-erp/core-web';
import { GridColDef } from '@mui/x-data-grid';
import { useState } from 'react';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { AuditQuestion } from '../types';
import { getAuditorQuestionssForMe } from '../api/getAuditorQuestionsForMe';

const AuditorQuestions = () => {
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const browseViewRef = useBrowseViewRef();

  const columns: GridColDef<AuditQuestion>[] = [
    {
      field: 'question',
      display: 'flex',
      headerName: t('Question', { defaultValue: 'Question' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
      valueGetter(_, row) {
        return JSON.parse(row.question).sl_SI || 'N/A';
      },
    },
    {
      field: 'answer',
      display: 'flex',
      headerName: t('Answer', { defaultValue: 'Answer' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
    },
  ];

  return (
    <>
      <div style={{ display: 'flex', gap: 5, marginBottom: '0.5rem' }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={startDate ? dayjs(new Date(startDate).toLocaleDateString('en-CA')) : dayjs('')}
            slotProps={{
              textField: {
                error: false,
              },
            }}
            onChange={(event) =>
              event
                ? setStartDate(new Date(event.date(1).toString()).toLocaleDateString('en-CA'))
                : {}
            }
            label={t('Start date', { defaultValue: 'Start date' })}
            format="YYYY-MM-DD"
          />
        </LocalizationProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            slotProps={{
              textField: {
                error: false,
              },
            }}
            value={endDate ? dayjs(new Date(endDate).toLocaleDateString('en-CA')) : dayjs('')}
            onChange={(event) =>
              event
                ? setEndDate(new Date(event.date(1).toString()).toLocaleDateString('en-CA'))
                : {}
            }
            label={t('End date', { defaultValue: 'End date' })}
            format="YYYY-MM-DD"
          />
        </LocalizationProvider>
        <Button
          variant="contained"
          onClick={() => {
            browseViewRef.current.reset();
          }}
        >
          {t('update', { defaultValue: 'update' })}
        </Button>
      </div>
      <BrowseView
        browserViewContainerSx={{
          height: '100vh',
        }}
        browseViewRef={browseViewRef}
        columns={columns}
        fetchData={(data) =>
          getAuditorQuestionssForMe({ ...data, dateFrom: startDate, dateTo: endDate })
        }
        toolbar={<BrowseView.Toolbar showSearch showDensityBtn />}
      />
    </>
  );
};

export default AuditorQuestions;
